import { ReactNode } from 'react';
import { useHasPermission } from '@lib/hooks/useHasPermission';

export type PermissionsType = {
  canCreateNewProject: boolean;
  canEditProject: boolean;
  canEditProjRegistry: boolean;
  canViewProjDocuments: boolean;
  canViewProjAdvancedSettings: boolean;
};

type PermissionWrapperProps = {
  children: (permissions: PermissionsType) => ReactNode;
};

export const PermissionWrapper = ({ children }: PermissionWrapperProps) => {
  // per attendere che i provider siano disponibili
  const permissions: PermissionsType = {
    canCreateNewProject: useHasPermission(['create-new-project'], 'all'),
    canEditProject: useHasPermission(['edit-project'], 'all'),
    canEditProjRegistry: useHasPermission(['edit-project-registry'], 'all'),
    canViewProjDocuments: useHasPermission(['access-documents-tab-project'], 'all'),
    canViewProjAdvancedSettings: useHasPermission(['access-advanced-settings-tab'], 'all'),
  };

  return <>{children(permissions)}</>;
};